import { formatDateToDayOfWeek, formatTimeToDisplayDayOfMonthTwoDigits } from '../../../../lib/dayjs';

export default class ScheduleTreatmentEventModel {
  public constructor(private props: { days: Date[] }) {}
  public formatDateToDisplayDayOfWeek(date: Date): string {
    return formatDateToDayOfWeek(date);
  }
  public formatTimeToDisplayDayOfMonthTwoDigits(date: Date): string {
    return formatTimeToDisplayDayOfMonthTwoDigits(date);
  }
  public selectCurrentDay(currentDate: Date): [Date, number] | null {
    const currentDay = this.props.days.find(
      day =>
        day.getDate() === currentDate.getDate() &&
        day.getMonth() === currentDate.getMonth() &&
        day.getFullYear() === currentDate.getFullYear()
    );
    if (!currentDay) return null;

    const index = this.props.days.indexOf(currentDay);
    return [currentDay, index];
  }
}
